export const API_EXTERNAL_ENDPOINT = 'cottages/home/best'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/cottages/home/best'
